import React, { useEffect } from 'react';
import { useAppDispatch } from '../../app/hooks';
import AppPage from '../common/AppPage';
import WeaveList from './WeaveList';
import WeaveLoadModal from './WeaveLoadModal';
import WeavePracModal from './WeavePracModal';
import WeaveSaveModal from './WeaveSaveModal';
import WeaveTrainerFooter from './WeaveTrainerFooter';
import WeaveTrainerHeader from './WeaveTrainerHeader';
import WeaveShareModal from './WeaveShareModal';
import { decodeBuild } from './weaveShareSlice';
import { useSearchParams } from 'react-router-dom';
import { getTrainerResults } from './weaveTrainerSlice';
import WeaveInfoModal from './WeaveInfoModal';

function WeaveTrainerPage() {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  
  useEffect(() => {
    if (code) {
      dispatch(decodeBuild(code));
      dispatch(getTrainerResults());
      //window.history.replaceState(null, '', window.location.pathname);
    }
  }, [dispatch, code]);

  return (
    <AppPage pageClass="weave-trainer-page">
      <div className="weave-trainer">
        <h5>WoTMud Weave Trainer</h5>
        <WeaveTrainerHeader />
        <WeaveList />
        <WeaveTrainerFooter />
        <WeaveInfoModal />
        <WeavePracModal />
        <WeaveSaveModal />
        <WeaveLoadModal />
        <WeaveShareModal />
      </div>
    </AppPage>
  );
}

export default WeaveTrainerPage;